import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled } from "@mui/material"

export const StyledDialog = styled(Dialog)({
  margin: "0 auto",
  padding: 0,

  "& .MuiPaper-root": {
    padding: "32px",
    margin: 0,
    maxWidth: "none",
    width: "100%",
    background: "#f4f4f4"
  }
})

export const Title = styled(DialogTitle)({
  lineHeight: "28px",
  marginBottom: "16px",
  padding: 0,
  fontSize: "20px",
  fontWeight: 700,
  color: "#564655"
})

export const StyledContent = styled(DialogContent)({
  marginBottom: "24px",
  padding: 0,
  color: "#333333"
})

export const StyledActions = styled(DialogActions)({
  padding: 0,
  gap: "24px",
  alignSelf: "flex-start",
  "& .MuiButton-root": {
    margin: 0
  }
})

export const StyledCloseButton = styled(IconButton)({
  position: "absolute",
  right: 0,
  top: 0,
  padding: "4px",
  margin: "4px"
})
